import axios from "axios";
import eventBus from "./eventBus";

// const SERVER_URL = "http://localhost:9001";
// const SERVER_URL = "http://49.50.166.245:9001"; // 개발서버

// const SERVER_URL = "http://27.96.130.79:9001"; // 운영

const SERVER_URL = "https://www.ferruminfra.com"; // 운영

const DOMAIN_URL = `${SERVER_URL}/api/`;
const NAS_URL = `${SERVER_URL}/nas/`;

const SUCCESS_CODE = 0;

axios.defaults.headers.common["Accept-Language"] = "ko";
// axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Content-Type"] = "application/json";
axios.defaults.headers["Accept"] = "application/json";

axios.defaults.timeout = 20000;

const setAuthToken = function (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

const networkErrorMsg = function () {
  console.log("networkErrorMsg - message");
  // eventBus.$emit("gToastMessage", {
  //   message: "네트워크 오류입니다. 다시 시도해 주시기 바랍니다.",
  //   type: "error"
  // });
};

const failCodeMsg = function (message) {
  console.log("failCodeMsg - message = " + message);
  // eventBus.$emit("gToastMessage", {
  //   message,
  //   type: "error"
  // });
};

const cmmFuncError = function (error, url) {
  console.log("cmmFuncError error~~~~~~!!");
  resData = error;

  //eventBus.$emit("gLoading", false);
  //console.error("cmmFuncError error url = " + url);

  try {
    if (error.message == "Network Error") {
      networkErrorMsg();
    } else {
      failCodeMsg("서버 오류가 발생했습니다.");
    }
  } catch (err) {
    networkErrorMsg();
  }
};

const post = function (url, params) {
  console.log("post url = " + `${DOMAIN_URL}` + url);
  console.log("req post params = " + JSON.stringify(params));
  // eventBus.$emit("gLoading", true);

  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: `${DOMAIN_URL}` + url,
      data: params
    })
      .then(
        result => {
          // eventBus.$emit("gLoading", false);
          console.log("res post url = " + `${DOMAIN_URL}` + url);

          resData = result.data;
          //console.log("res params = " + JSON.stringify(resData));

          if (result.data.resultCode != SUCCESS_CODE) {
            //console.error("res !!! SUCCESS_CODE & error url = " + url);
            failCodeMsg(
              result.data.resultMessage || "서버 오류가 발생했습니다."
            );
            reject(result.data);
          }
          resolve(result.data);
        },
        error => {
          cmmFuncError(error, url);
          reject(error);
        }
      )
      .catch(error => {
        console.log("post error !!!!!!!!!!!!!!");
        cmmFuncError(error, url);
        reject(error);
      });
  });
};

const fileUpload = function (url, formData) {
  console.log("fileUpload url = " + `${DOMAIN_URL}` + url);
  reqData = formData;
  // eventBus.$emit("gLoading", true);

  return new Promise((resolve, reject) => {
    axios
      .post(`${DOMAIN_URL}` + url, formData)
      .then(
        result => {
          // eventBus.$emit("gLoading", false);
          console.log("res post url = " + `${DOMAIN_URL}` + url);

          resData = result.data;

          if (result.data.resultCode != SUCCESS_CODE) {
            console.error("res !!! SUCCESS_CODE & error url = " + url);
            failCodeMsg(
              result.data.resultMessage || "서버 오류가 발생했습니다."
            );
            reject(result.data);
          }
          resolve(result.data);
        },
        error => {
          cmmFuncError(error, url);
          reject(error);
        }
      )
      .catch(error => {
        console.log("post error !!!!!!!!!!!!!!");
        cmmFuncError(error, url);
        reject(error);
      });
  });
};

const get = function (url, params) {
  reqData = params;

  console.log("get url = " + `${DOMAIN_URL}` + url);
  // eventBus.$emit("gLoading", true);

  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: `${DOMAIN_URL}` + url
    }).then(
      result => {
        // eventBus.$emit("gLoading", false);

        resData = result.data;

        if (result.data.resultCode != SUCCESS_CODE) {
          console.error("res 200 & error url = " + url);
          failCodeMsg(result.data.statusMsg || "서버 오류가 발생했습니다.");
          reject(result.data);
        }
        resolve(result.data);
      },
      error => {
        cmmFuncError(error, url);
        reject(error);
      }
    );
  });
};

export default {
  post,
  get,
  fileUpload,
  setAuthToken,
  NAS_URL
};



// WEBPACK FOOTER //
// ./src/components/common/protocolManager.js